<template>
    <div class="wrm-load-unload-pane">
        <m-pane
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="page.pageTotal"
            :loading="loading"
            :currentPage="page.pageNo"
            :class="isSupplier ? 'supplier-pane' : ''"
            searchId="abnormalAssessLoadUnloadSearchId_20251108"
            pageID="abnormalAssessLoadUnloadPageId_20251108"
            @btnClick="handleBtnClick"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
        >
            <div slot="table-module-btn">
                <el-tooltip effect="dark" content="导出" placement="bottom">
                    <el-button
                        :loading="exportLoading"
                        size="mini"
                        icon="el-icon-download"
                        @click="handleExport()"></el-button>
                </el-tooltip>
            </div>
        </m-pane>
        <Preview
            v-if="attachmentShow"
            :attachmentList="attachmentList"
            :attachmentShow.sync="attachmentShow"
            :rowData="rowData"
        ></Preview>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import bigDataLog from '@/utils/bigDataLog';
import mPane from '@/components/supplierPanel';
import Preview from '../../../components/viewAttachment.vue';
import config from './loadUnloadConfig.js';
import { getExceptionDetailSummary, exportSupplierExceptionDetailSummary } from '../../../api/warehouseResourceManagement/abnormalAssess.js';
import { dictWithUrl } from '@/components/lots/api';
export default {
    components: { mPane, Preview },
    props: {
        isSupplier: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            reportCode: 'SRM_ABNORMAL_ASSESS_UNLOAD_EXP',
            loading: false,
            exportLoading: false,
            totalData: [],
            searchObj: {
                createStartTime: dayjs().subtract(90, 'd').format('YYYY-MM-DD 00:00:00'),
                createEndTime: dayjs().format('YYYY-MM-DD 23:59:59')
            },
            page: {
                pageNo: 1,
                pageSize: 10,
                pageTotal: 0
            },
            attachmentShow: false,
            rowData: {},
            attachmentList: [],
            dictData: {},
        };
    },
    computed: {
        config() {
            if (this.isSupplier) {
                config.searchList = config.lspSearchList;
                config.table.height = config.table.lspHeight;
            }
            return config;
        }
    },
    methods: {
        // selectChange(data) {
        //     this.selected = data;
        // },
        getTableData() {
            this.loading = true;
            getExceptionDetailSummary(this.getParams()).then(res => {
                if (res && +res.code === 0) {
                    this.page.pageTotal = res.data.totalCount;
                    this.totalData = res.data.list;
                }
            }).finally(() => { this.loading = false; });
        },
        getParams() {
            const params = JSON.parse(JSON.stringify(this.searchObj));
            params.assessmentExceptionType = '1'; // 1 装卸
            params.pageNo = this.page.pageNo;
            params.pageSize = this.page.pageSize;
            if (params.assessmentMonthList && params.assessmentMonthList.length) {
                params.assessmentStartMonth = dayjs(params.assessmentMonthList[0]).format('YYYY-MM');
                params.assessmentEndMonth = dayjs(params.assessmentMonthList[1]).format('YYYY-MM');
            }
            if (this.isSupplier) {
                params.supplierCodeList = [this.$store.state.supplier.supplierCode];
                delete params.createStartTime;
                delete params.createEndTime;
            } else {
                if (params.supplierCode) {
                    params.supplierCodeList = params.supplierCode.split(',');
                }
                if (params.createTimeArr && params.createTimeArr.length) {
                    params.createStartTime = dayjs(params.createTimeArr[0]).format('YYYY-MM-DD HH:mm:ss');
                    params.createEndTime = dayjs(params.createTimeArr[1]).format('YYYY-MM-DD HH:mm:ss');
                }
            }
            if (params.logicalWarehouseCode) {
                params.logicalWarehouseCodeList = params.logicalWarehouseCode.split(',');
            }
            delete params.assessmentMonthList;
            delete params.supplierCode;
            delete params.supplierName;
            delete params.logicalWarehouseCode;
            delete params.logicalWarehouseName;
            delete params.createTimeArr;
            return params;
        },
        searchChange(data) { // 点击查询
            this.page.pageNo = 1;
            this.searchObj = data;
            this.getTableData();
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,供应商异常管理,异常考核,装卸-查询'); } catch (e) { }
        },
        pageChange(pageNo) { // 切换分页页数
            this.page.pageNo = pageNo;
            this.getTableData();
        },
        sizeChange(pageSize) { // 切换分页显示条数
            this.page.pageNo = 1;
            this.page.pageSize = pageSize;
            this.getTableData();
        },
        handleBtnClick(val, index, row, prop, buttonName) {
            if (!val) {
                return this.$message.warning('暂无附件!');
            }
            this.rowData = {
                downUrl: val
                // fileName: row.attachmentFileName,
                // fileId: data.fileId
            };
            this.attachmentShow = true;
            // if (!val) {
            //     return this.$message.warning('暂无附件!')
            // }
            // if (buttonName === '查看') {
            //     this.rowData = {
            //         downUrl: val,
            //         fileName: row.attachmentFileName,
            //         // fileId: data.fileId
            //     };
            //     this.attachmentShow = true;
            // } else if (buttonName === '下载') {
            //     let a = document.createElement('a');
            //     a.href = val;
            //     a.download = row.attachmentFileName;
            //     a.click();
            // }
        },
        handleExport() {
            const params = {
                ...this.getParams(),
                reportCode: '50520302-3697-4ed9-81ed-5be867c97d29'
            };
            delete params.pageNo;
            delete params.pageSize;
            this.exportLoading = true;
            exportSupplierExceptionDetailSummary(params).then((res)=>{
                if (res && +res.code === 0) {
                    this.$message.success('文件处理中，稍后请留意右上角文件中心下载文件！')
                }
            }).finally(()=>{
                this.exportLoading = false;
            });
            try { bigDataLog.sendDetailMessageByNames('仓储供应商管理,供应商异常管理,异常考核,装卸-导出'); } catch (e) { }
        }
    },
    mounted() {
        dictWithUrl('AMS_FIRST_PROBLEM_V2,AMS_SECOND_PROBLEM_V2').then(res => {
            this.dictData = res.data
            this.getTableData()
        })
    }
};
</script>
<style lang="less">
.wrm-load-unload-pane {
    #mPane3.supplier-pane .el-table {
        min-height: calc(100vh - 222px);
        max-height: calc(100vh - 222px);
    }

    #mPane3 .el-table {
        min-height: calc(100vh - 260px);
        max-height: calc(100vh - 260px);
    }
}
</style>
